import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { FieldRenderProps } from 'react-final-form'
import classNames from 'classnames'
import { getNextDate } from '../../utils/getDays/getNextDate'
import 'date-fns'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { useIntl } from 'react-intl'
import MomentUtils from '@date-io/moment'
import 'moment/locale/fr'
import 'moment/locale/en-gb'
import { getNextYearDate } from '../../utils/getDays/getNextYearDate'
import { getToday } from '../../utils/getDays/getToday'
import { Grid, useTheme } from '@material-ui/core'
import SvgCalendar from '../../icons/SvgCalendar'
import languages from '../../enums/languagesEnum'
import { getDefaultBirthDate } from '../../utils/getDays/getMinBirthDate'
import { WHITE } from '../../theme'

const useStyles = makeStyles(
	(theme) => (
		{
			...styles(theme),
			errorStyle: {
				color: '#B92D00',
				fontSize: 18,
				fontWeight: 500,
				opacity: 0.7,
				lineHeight: 1.33
			},
			errorColor: {
				color: '#B92D00 !important'
			},
			inputRoot: {
				borderRadius: 40,
				border: `0.5px solid ${theme.palette.blue['30']}`,
				backgroundColor: theme.palette.blue['5']
			},
			input: {
				padding: '15px 24px'
			},
			focused: {
				border: `0.5px solid ${theme.palette.blue['30']}`
			},
			button: {
				opacity: 0.5
			},
			dropDownPaper: {
				marginTop: 8,
				borderRadius: 8,
				boxShadow: '0 10px 20px 0 rgba(18, 41, 65, 0.2)',

				'& .MuiPickersToolbar-toolbar': {
					backgroundColor: theme.palette.accessibility.main,

					'& .MuiPickersToolbarText-toolbarTxt, & .MuiPickersToolbarText-toolbarBtnSelected': {
						color: WHITE
					}
				}
			},
			buttonManual: {
				display: 'none'
			},
		}
	)
)

interface AcceptingProps {
	id: string,
	label?: string,
	inputTextStyle?: string,
	disableToolbar?: boolean,
	isGreyBackground?: boolean,
	selectFuture?: boolean,
	hasDefault?: boolean,
	manual?: boolean,
	setMinDate?: string,
	emptyLabel?: string
}

type FormDatePickerAcquiResiFieldProps =
	FieldRenderProps<string>
	& AcceptingProps

const FormDatePickerAcquiResiField: React.FC<FormDatePickerAcquiResiFieldProps> = (
	{
		input,
		meta: {
			touched,
			error
		},
		inputTextStyle,
		disableToolbar = true,
		isGreyBackground = true,
		selectFuture = true,
		hasDefault = true,
		manual = false,
		emptyLabel = '',
		setMinDate
	}
) => {
	const classes = useStyles()
	const theme = useTheme()
	const intl = useIntl()
	const [open, setOpen] = useState<boolean>(false)

	const nth = (date: Date) => {
		const day: number = date.getDate()
		if (day > 3 && day < 21) return 'th'
		switch (day % 10) {
			case 1:
				return 'st'
			case 2:
				return 'nd'
			case 3:
				return 'rd'
			default:
				return 'th'
		}
	}

	return (
		<Grid container>
			<MuiPickersUtilsProvider utils={MomentUtils} locale={intl.locale}>
				<KeyboardDatePicker
					autoOk
					disableToolbar={disableToolbar}
					onClose={() => setOpen(false)}
					fullWidth
					open={open}
					emptyLabel={emptyLabel}
					variant="inline"
					minDate={setMinDate && setMinDate.length > 0 ? setMinDate : selectFuture ? getNextDate() : null}
					maxDate={selectFuture ? getNextYearDate() : getToday()}
					minDateMessage={intl.locale === languages.fr ? 'La date ne doit pas être antérieure à la date minimale' : 'Date should not be before minimal date'}
					maxDateMessage={intl.locale === languages.fr ? 'La date ne doit pas être postérieure à la date maximale' : 'Date should not be after maximal date'}
					format={manual ? 'DD/MM/yyyy' : intl.locale === languages.fr ? 'D MMMM yyyy' : `D[${nth(new Date(input.value))}] MMMM yyyy`}
					invalidDateMessage={intl.locale === languages.fr ? 'Format invalide' : 'Invalid Format'}
					value={input.value && input.value.length > 0 ? input.value : (hasDefault ? getDefaultBirthDate() : null)}
					InputAdornmentProps={{ position: "start" }}
					keyboardIcon={<SvgCalendar color={theme.palette.blue.main} width={35} height={40} />}
					onChange={(a: any) => {
						if (a) {
							return input.onChange(a.format('yyyy-MM-DD'))
						}

						return input.onChange('')
					}}
					KeyboardButtonProps={{
						classes: {
							root: manual ? classes.buttonManual : classes.button
						}
					}}
					InputProps={{
						classes: {
							root: classNames({ [classes.inputRoot]: isGreyBackground }),
							input: classNames(
								inputTextStyle,
								{
									[classes.input]: isGreyBackground
								}
							),
							focused: classes.focused
						},
						disableUnderline: true,
						readOnly: !manual,
						onClick: () => !manual && setOpen(true)
					}}
					PopoverProps={{
						classes: {
							paper: classes.dropDownPaper
						}
					}}
					FormHelperTextProps={{
						className: inputTextStyle
					}}
				/>
			</MuiPickersUtilsProvider>
			{
				touched &&
				((error && <span className={classes.errorStyle}>{error}</span>))
			}
		</Grid>
	)
}

export default FormDatePickerAcquiResiField
